var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"account-pages my-5 pt-5"},[_c('div',{staticClass:"container"},[_vm._m(0),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-8 col-lg-6 col-xl-5"},[_c('router-view')],1)])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 auth-logo"},[_c('img',{attrs:{"src":require("@/assets/images/logo-full.png")}})])
}]

export { render, staticRenderFns }